<script>
import { mapActions } from "vuex";
import { required } from '@vuelidate/validators'
import CustomerGroup from "@/models/CustomerGroup.vue";

import BaseCustomerGroupDialogSelector from "@/components/shared/BaseDialogSelectors/BaseCustomerGroupDialogSelector.vue";

export default {
  extends: CustomerGroup,
  components: {
    BaseCustomerGroupDialogSelector,
  },
  computed: {
    title() {
      return this.id ? `Edit ${this.modelName}` : `Create ${this.modelName}`;
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    ...mapActions("customerGroups", ["upsertCustomerGroup"]),
    ...mapActions("application", ["setIsConfirmLoading", "warnValidation"]),

    async show() {
      this.initialize();
      this.showModal = true;
    },

    async upsert(e) {
      this.v$.$touch();
      if (this.v$.$invalid) {
        this.warnValidation();
        return;
      } else {
        this.setIsConfirmLoading(true);
        try {
          if (this.is_parent) { this.parent = null; }
          const res = await this.upsertCustomerGroup(this.customer_group);
          this.$emit("upserted", res.data.data);
          this.showModal = false;
        } catch {
        } finally {
          this.setIsConfirmLoading(false);
        }
      }
    },
  },
  watch: {
    showModal() {
      this.v$.$reset();
    }
  },
  validations() {
    return this.showModal
      ? {
        name: { required },
        }
      : { };
  },
};
</script>

<template>
  <div>
    <base-modal v-model="showModal" :title="title" @upsert="upsert">
      <form @submit.prevent="upsert">
        <div class="row">
          <div class="col-sm-12">
            <div class="row mb-2">
              <div class="col-sm-12">
                <base-input
                  label="Name"
                  type="text"
                  v-model="name"
                  :validation="v$.name"
                  required
                />
              </div>
            </div>

            <div class="row gap-2 gap-sm-0">
              <div class="col-sm-6">
                <base-binary-button
                  id="parent"
                  label="Group Hierarchy"
                  variant="primary"
                  falseLabel="Child"
                  trueLabel="Parent"
                  v-model="is_parent"
                ></base-binary-button>
              </div>
              <div class="col-sm-6" v-if="is_parent == false">
                <BaseCustomerGroupDialogSelector v-model="parent" disableAdd disableModals disableQuickAdd />
              </div>
            </div>
          </div>
        </div>
      </form>
    </base-modal>
  </div>
</template>
